import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "m-6 text-gray-800" }
const _hoisted_4 = { class: "font-bold text-3xl" }
const _hoisted_5 = { class: "m-4 text-gray-800" }
const _hoisted_6 = { class: "py-6" }
const _hoisted_7 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_8 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }
const _hoisted_9 = { class: "bg-white" }
const _hoisted_10 = { class: "flex justify-between items-center" }
const _hoisted_11 = { class: "m-8 text-gray-800" }
const _hoisted_12 = { class: "font-bold text-3xl" }
const _hoisted_13 = { class: "m-4 text-gray-800" }
const _hoisted_14 = { class: "py-6" }
const _hoisted_15 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_16 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { inject, onMounted, ref, watch } from "vue";
import DataTable from "@/components/tools/DataTable.vue";
import { translate } from "@/utils/tools";
import PaymentConfigEditDepositTieringDialog from "@/components/dialogs/PaymentConfigEditDepositTieringDialog.vue";
import PaymentConfigAddDepositBankDialog from "@/components/dialogs/PaymentConfigAddDepositBankDialog.vue";
import PaymentConfigEditDepositBankDialog from "@/components/dialogs/PaymentConfigEditDepositBankDialog.vue";
import Toast from "@/components/tools/Toast.vue";
import PaymentConfigAddDepositTieringDialog from "@/components/dialogs/PaymentConfigAddDepositTieringDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentDepositTieringConfig',
  setup(__props) {

dayjs.extend(localizedFormat);
const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const dataRowsDepositTiering = ref([]);
const dataRowsDepositBank = ref([]);
const isDepositTieringLoaded = ref(false);
const isDepositBankLoaded = ref(false);
const columnsDepositTiering = ref([
  {
    label: translate("messages.paymentDepositTieringConfig.depositTieringPriority"),
    field: "priority",
    align: "center",
    sort: false,
    class: () => 'flex items-center justify-center',
  },
  {
    label: translate("messages.paymentDepositTieringConfig.depositTieringName"),
    field: "name",
    align: "center",
    sort: false,
    class: () => 'flex items-center justify-center',
  },
  {
    label: translate("messages.paymentDepositTieringConfig.depositTieringAccumulatedAmount"),
    field: "accumulatedAmount",
    align: "center",
    sort: false,
    format: (data: any) => data.accumulatedAmount!==null? data.accumulatedAmount/100 : "-",
    class: () => 'flex items-center justify-center',

  },
  {
    label: translate("messages.paymentDepositTieringConfig.depositTieringAccumulatedDepositTransaction"),
    field: "accumulatedDepositTransaction",
    align: "center",
    sort: false,
    format: (data: any) => data.accumulatedDepositTransaction!==null? data.accumulatedDepositTransaction : "-",
    class: () => 'flex items-center justify-center',


  },
  {
    label: translate("messages.paymentDepositTieringConfig.depositTieringAccountName"),
    field: "accountName",
    align: "center",
    sort: false,
    format: (data: any) => {
      let mapping: any[] = []
      if(data.OperatorDepositTieringsMappings){
        mapping = data.OperatorDepositTieringsMappings.map((item: any) => {
          if(item.OperatorDeposit){
            return `${item.OperatorDeposit.name}`
          }
        })
        .filter(Boolean);
      }

      return mapping.length ? mapping.join(', ') : '-';
    },
    class: () => 'flex items-center justify-center',

  },
  {
    label: translate("messages.paymentDepositTieringConfig.depositTieringPaymentName"),
    field: "accountName",
    align: "center",
    sort: false,
    format: (data: any) => {
      let mapping: any[] = [];
    if (data.OperatorDepositTieringsMappings) {
      mapping = data.OperatorDepositTieringsMappings
        .map((item: any) => {
          if (item.OperatorPaymentGateway) {
              return `${item.OperatorPaymentGateway.Payment.name}`
            }
        })
        .filter(Boolean);
    }
    return mapping.length ? mapping.join(', ') : '-';
     
    },
    class: () => 'flex items-center justify-center',

  },
  {
    label:"",
    field: "status",
    align: "center",
    sort: false,
    isSorted: false,
    isFunction: true,
    function: async (data: any) => {
      await pushUpPriority(data)
    },
    class: (data: any) => {
      if(data.priority == minPriorityDepositTiering.value.priority) return ''
      return 'mx-auto content-center bg-green-500 hover:bg-green-700 text-white font-bold rounded-full'
    },
    format: (data: any) => {
      if(data.priority == minPriorityDepositTiering.value.priority) return ''
      return translate("messages.paymentDepositTieringConfig.depositTieringEditPriorityUp")
    },
    // permission: 'PAYMENT_CONFIG.OPERATOR_PAYMENT_DEPOSIT_TIERING.UPDATE'
  },
  {
    label: "",
    field: "status",
    align: "center",
    sort: false,
    isSorted: false,
    isFunction: true,
    function: async (data: any) => {
      await pushDownPriority(data)
    },
    class: (data: any) => {
      if(data.priority == maxPriorityDepositTiering.value.priority) return ''
      return 'mx-auto content-center bg-green-500 hover:bg-green-700 text-white font-bold rounded-full'
    },
    format: (data: any) => {
      if(data.priority == maxPriorityDepositTiering.value.priority) return ''
      return translate("messages.paymentDepositTieringConfig.depositTieringEditPriorityDown")
    },
    // permission: 'PAYMENT_CONFIG.OPERATOR_PAYMENT_DEPOSIT_TIERING.UPDATE'
  },
  {
    label: translate("messages.paymentDepositTieringConfig.depositTieringEdit"),
    field: "status",
    align: "center",
    sort: false,
    isSorted: false,
    isFunction: true,
    function: async (data: any) => {
      //set form data
      selectedPaymentDepositTieringForm.value = {...data,accumulatedAmount: data.accumulatedAmount/100 };
      //show modal
      showEditPaymentDepositTieringForm.value = true
      return
    },
    class: (data: any) => {
      return 'mx-auto content-center bg-blue-500 hover:bg-blue-700 text-white font-bold rounded-full'
    },
    format: (data: any) => {
      return translate("messages.paymentDepositTieringConfig.depositTieringEdit")
    },
    // permission: 'PAYMENT_CONFIG.OPERATOR_PAYMENT_DEPOSIT_TIERING.UPDATE'
  },
  {
    label: translate("messages.paymentDepositTieringConfig.depositTieringDelete"),
    field: "delete",
    align: "center",
    sort: false,
    isSorted: false,
    isFunction: true,
    function: async (data: any) => {
      removeDepositTiering(data.id)
      return
    },
    class: (data: any) => {
      return 'mx-auto content-center bg-red-500 hover:bg-red-700 text-white font-bold rounded-full'
    },
    format: (data: any) => {
      return translate("messages.paymentDepositTieringConfig.depositTieringDelete")
    },
    // permission: 'PAYMENT_CONFIG.OPERATOR_PAYMENT_DEPOSIT_TIERING.UPDATE'
  },
]);
const columnsDepositBank = ref([
  {
    label: translate("messages.paymentDepositTieringConfig.depositBankName"),
    field: "name",
    align: "align-center",
    sort: false,
    class: () => 'flex items-center justify-center',
  },
  {
    label: translate("messages.paymentDepositTieringConfig.depositBankProvider"),
    field: "Bank",
    align: "align-center",
    sort: false,
    format: (data: any) => data.Bank.code,
    class: () => 'flex items-center justify-center',
  },
  {
    label: translate("messages.paymentDepositTieringConfig.depositBankBankAccountNameTh"),
    field: "bankAccountNameTh",
    align: "center",
    sort: false,
    class: () => 'flex items-center justify-center',
  },
  {
    label: translate("messages.paymentDepositTieringConfig.depositBankBankAccountNumber"),
    field: "bankAccountNumber",
    align: "center",
    sort: false,
    class: () => 'flex items-center justify-center',
  },
  {
    label: translate("messages.paymentDepositTieringConfig.depositTieringEdit"),
    field: "status",
    align: "center",
    sort: false,
    isSorted: false,
    isFunction: true,
    function: async (data: any) => {
      selectedEditPaymentDepositForm.value = data
      showEditPaymentDepositBank.value = true
      //set form data
      //show modal
      return
    },
    class: (data: any) => {
      return 'mx-auto content-center bg-blue-500 hover:bg-blue-700 text-white font-bold rounded-full'
    },
    format: (data: any) => {
      return translate("messages.paymentDepositTieringConfig.depositTieringEdit")
    },
    // permission: 'PAYMENT_CONFIG.OPERATOR_PAYMENT_DEPOSIT_TIERING.UPDATE'
  },
  {
    label: translate("messages.paymentDepositTieringConfig.depositTieringDelete"),
    field: "delete",
    align: "center",
    sort: false,
    isSorted: false,
    isFunction: true,
    function: async (data: any) => {
      removeDepositBank(data.id)
      return
    },
    class: (data: any) => {
      return 'mx-auto content-center bg-red-500 hover:bg-red-700 text-white font-bold rounded-full'
    },
    format: (data: any) => {
      return translate("messages.paymentDepositTieringConfig.depositTieringDelete")
    },
    // permission: 'PAYMENT_CONFIG.OPERATOR_PAYMENT_DEPOSIT_TIERING.UPDATE'
  },

]);
const dataRowsBankProvider = ref([])
const toastConfig = ref({show: false, message: '', success: false})
const maxPriorityDepositTiering = ref(0)
const minPriorityDepositTiering = ref(0)
// dialog edit payment deposit tiering
const selectedPaymentDepositTieringForm = ref({})
const showEditPaymentDepositTieringForm = ref(false)
const onSubmitEditPaymentDepositTiering = async (payload) => {
  try {
    const bankMappings = payload.selectedDepositPaymentOption?.bank?.map((item: { value: any; }) => ({
    type: "account",
    id: item.value,
  }));

  const pgwMappings = payload.selectedDepositPaymentOption?.pgw?.map((item: { value: any; }) => ({
    type: "paymentGateway",
    id: item.value,
  }));

    const tieringMapping =[...bankMappings, ...pgwMappings]
    const request ={
      operatorId: store.state.selectedOperator.operatorId,
      name: payload.depositTiering.name,
      priority: payload.depositTiering.priority,
      accumulatedAmount: payload.depositTiering.accumulatedAmount*100,
      accumulatedDepositTransaction: payload.depositTiering.accumulatedDepositTransaction,
      tieringMapping
    }
    const url = payload.depositTiering.id? `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-tiering/update/${payload.depositTiering.id}`:`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-tiering/create`;
    const response = await axios
    .post(url, request)
    .then(({ data }) => data);
    if(response.id) fetchPageDepositTieringData();
    showEditPaymentDepositTieringForm.value = false
    toastConfig.value = {show: true, message: `success`, success: true}
    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
  }catch (e){
    toastConfig.value = {show: true, message: e.message, success: false}

    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
  }
}
const onCloseEditPaymentDepositTiering = async () => {
  selectedPaymentDepositTieringForm.value = {}
  showEditPaymentDepositTieringForm.value = false
}

// dialog add payment deposit bank
const showAddPaymentDepositBank = ref(false)
const addPaymentDepositForm = ref({
  bankId: null,
  bankAccountNumber: "",
  bankAccountNameTh: "",
  bankAccountNameEn: "",
  name: ""
})
const onSubmitAddPaymentDepositBank = async (payload) => {
  try {
    const request: any = {
      operatorId: store.state.selectedOperator.operatorId,
      bankId: payload.bankId,
      bankAccountNumber: `${payload.bankAccountNumber}`,
      bankAccountNameTh: payload.bankAccountNameTh,
      bankAccountNameEn: payload.bankAccountNameEn,
      name:payload.name,
    };
    const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-bank/create`;
    const response = await axios
    .post(url, request)
    .then(({ data }) => data);
    if(response.id) fetchPageDepositBankData();
    showAddPaymentDepositBank.value = false
    addPaymentDepositForm.value = {
      bankId: null,
      bankAccountNumber: "",
      bankAccountNameTh: "",
      bankAccountNameEn: "",
      name: ""
    }
    toastConfig.value = {show: true, message: `success`, success: true}
    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
  }catch (e){
    toastConfig.value = {show: true, message: e?.response?.data?.message?.bankAccountNumber, success: false}

    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
  }
}
const onCloseAddPaymentDepositBank = async () => {
  showAddPaymentDepositBank.value = false
}

//dialog edit payment deposit bank
const showEditPaymentDepositBank = ref(false)
const selectedEditPaymentDepositForm = ref({})
const onSubmitEditPaymentDepositBank = async (payload) => {
  try {
    const {id,Bank, BankId, operatorId, updatedAt, createdAt,...request} = payload
    const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-bank/update/${id}`;
    const response = await axios
    .post(url, request)
    .then(({ data }) => data);
    if(response.id) fetchPageDepositBankData();
    showEditPaymentDepositBank.value = false
    toastConfig.value = {show: true, message: `success`, success: true}
    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
  }catch (e){
    toastConfig.value = {show: true, message: e?.response?.data?.message?.bankAccountNumber, success: false}

    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
  }
}
const onCloseEditPaymentDepositBank = async () => {
  showEditPaymentDepositBank.value = false
}

const showAddPaymentDepositTiering = ref(false)

const addPaymentDepositTieringForm = ref({
  name: null,
  priority: 0,
  accumulatedAmount: null,
  accumulatedDepositTransaction: null,
  operatorPaymentDeposit: {
    id: null,
  }
},)

const onSubmitAddPaymentDepositTiering = async (payload:any) => {
  try {
    const bankMappings = payload.selectedDepositPaymentOption?.bank?.map((item: { value: any; }) => ({
    type: "account",
    id: item.value,
  }));

  const pgwMappings = payload.selectedDepositPaymentOption?.pgw?.map((item: { value: any; }) => ({
    type: "paymentGateway",
    id: item.value,
  }));

    const tieringMapping =[...bankMappings, ...pgwMappings]
    const request ={
      operatorId: store.state.selectedOperator.operatorId,
      name: payload.depositTiering.name,
      priority: (dataRowsDepositTiering.value.length !== 0)?dataRowsDepositTiering.value[dataRowsDepositTiering.value.length - 1].priority + 1 : 1,
      accumulatedAmount: payload.depositTiering.accumulatedAmount*100,
      accumulatedDepositTransaction: payload.depositTiering.accumulatedDepositTransaction,
      tieringMapping
    }

    const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-tiering/create`
    const response = await axios
    .post(url, request)
    .then(({ data }) => data);
    if(response.id) fetchPageDepositTieringData();
    showAddPaymentDepositTiering.value = false
    toastConfig.value = {show: true, message: `success`, success: true}
    addPaymentDepositTieringForm.value = {
      name: null,
      priority: 0,
      accumulatedAmount: null,
      accumulatedDepositTransaction: null,
      operatorPaymentDeposit: {
        id: null,
      }
    }
    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
  }catch (e){
    toastConfig.value = {show: true, message: e?.response?.data?.message?.bankAccountNumber, success: false}

    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
  }
}

const onCloseAddPaymentDepositTiering = async () => {
  showAddPaymentDepositTiering.value = false
}

const pushUpPriority = async (payload) => {
  try {
    isDepositTieringLoaded.value = false;
    const findUpperTiering = dataRowsDepositTiering.value.find((dt) => dt.priority === payload.priority-1)

    const requestTarget = {id:payload.id, priority: payload.priority-1}
    console.log(requestTarget)
    const urlUp = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-tiering/set-priority`
    const up =  await axios
    .post(urlUp, requestTarget)
    if(up.status!==201) throw new Error('failed!! contact support')

    if(findUpperTiering){
      const request = {id:findUpperTiering.id, priority: payload.priority}
      const urlDown = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-tiering/set-priority`
      const down = await axios
          .post(urlDown, request)
      if(down.status!==201) throw new Error('failed!! contact support')

    }


    toastConfig.value = {show: true, message: `success`, success: true}
    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
    await fetchPageDepositTieringData();
  }catch (e){
    toastConfig.value = {show: true, message: e.message, success: false}

    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
  } finally {
    isDepositTieringLoaded.value = true;
  }
}

const pushDownPriority = async (payload) => {
  try {
    isDepositTieringLoaded.value = false;
    const findLowerTiering = dataRowsDepositTiering.value.find((dt) => dt.priority === payload.priority+1)

    const requestTarget = {id:payload.id, priority: payload.priority+1}
    const urlUp = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-tiering/set-priority`
    const up =  await axios
    .post(urlUp, requestTarget)
    if(up.status!==201) throw new Error('failed!! contact support')


    const request = {id:findLowerTiering.id, priority: payload.priority}
    const urlDown = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-tiering/set-priority`
    const down = await axios
    .post(urlDown, request)
    if(down.status!==201) throw new Error('failed!! contact support')


    toastConfig.value = {show: true, message: `success`, success: true}
    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
    await fetchPageDepositTieringData();
  }catch (e){
    toastConfig.value = {show: true, message: e.message, success: false}

    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
  } finally {
    isDepositTieringLoaded.value = true;
  }
}

const removeDepositTiering = async (id) => {
  try {
    if(confirm("Remove Deposit Tiering ?")){
      const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-tiering/delete/${id}`;
      const response = await axios
      .post(url)
      if(response.status==201) fetchPageDepositTieringData();
      toastConfig.value = {show: true, message: `success`, success: true}
      setTimeout(() => {
        toastConfig.value = {show: false, message: ``, success: false}
      }, 3000)
    }
  }catch (e){
    toastConfig.value = {show: true, message: e.message, success: false}

    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
  }
}

const removeDepositBank = async (id) => {
  try {
    if(confirm("Remove Deposit Bank ?")){
      const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-bank/delete/${id}`;
      const response = await axios
      .post(url)
      if(response.status==201) fetchPageDepositBankData();
      toastConfig.value = {show: true, message: `success`, success: true}
      setTimeout(() => {
        toastConfig.value = {show: false, message: ``, success: false}
      }, 3000)
    }
  }catch (e){
    toastConfig.value = {show: true, message: `found this bank using can't remove!!`, success: false}

    setTimeout(() => {
      toastConfig.value = {show: false, message: ``, success: false}
    }, 3000)
  }
}

const findMaxValueOfProperty = (arr, property) => {
  if (!arr || arr.length === 0) {
    return undefined; // Or throw an error, depending on desired behavior for empty arrays
  }

  return arr.reduce((max, current) => {
    return current[property] > max[property] ? current : max;
  }, arr[0]); // Initialize with the first object in the array
}

const findMinValueOfProperty = (arr, property) => {
  if (!arr || arr.length === 0) {
    return undefined; // Or throw an error, depending on desired behavior for empty arrays
  }

  return arr.reduce((min, current) => {
    return current[property] < min[property] ? current : min;
  }, arr[0]); // Initialize with the first object in the array
}

const fetchPageDepositTieringData = async () => {
  isDepositTieringLoaded.value = false;
  const payload: any = {
    operatorId: store.state.selectedOperator.operatorId,
    page:1,
    pageSize: 999,
  };
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-tiering/pagination`;
  const { result: data } = await axios
  .post(url, payload)
  .then(({ data }) => data);

  dataRowsDepositTiering.value = data.sort((a, b) => a.priority - b.priority);
  maxPriorityDepositTiering.value = findMaxValueOfProperty(dataRowsDepositTiering.value, 'priority');
  minPriorityDepositTiering.value = findMinValueOfProperty(dataRowsDepositTiering.value, 'priority');
  isDepositTieringLoaded.value = true;
};

const fetchPageDepositBankData = async () => {
  isDepositBankLoaded.value = false;
  const payload: any = {
    operatorId: store.state.selectedOperator.operatorId,
    page:1,
    pageSize: 999,
  };
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-deposit-bank/pagination`;
  const { result: data } = await axios
  .post(url, payload)
  .then(({ data }) => data);



  dataRowsDepositBank.value = data
  isDepositBankLoaded.value = true;
};

const fetchPageDepositBankProviderData = async () => {
  const payload: any = {
    page:1,
    pageSize: 999,
  };
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/bank/pagination`;
  const { result: data } = await axios
  .post(url, payload)
  .then(({ data }) => data);


  dataRowsBankProvider.value = data

};


onMounted(() => {
  fetchPageDepositTieringData();
  fetchPageDepositBankData();
  fetchPageDepositBankProviderData();
});


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('messages.paymentDepositTieringConfig.paymentDepositTieringConfig')), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = () => {showAddPaymentDepositTiering.value= true}),
              class: "ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "mr-2",
                icon: ['far', 'file-export']
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.paymentDepositTieringAdd")), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(DataTable, {
              columns: columnsDepositTiering.value,
              data: dataRowsDepositTiering.value,
              isLoaded: isDepositTieringLoaded.value
            }, null, 8, ["columns", "data", "isLoaded"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.$t('messages.paymentDepositTieringConfig.paymentDepositBankConfig')), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = () => {showAddPaymentDepositBank.value= true}),
              class: "ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "mr-2",
                icon: ['far', 'file-export']
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.paymentDepositTieringConfig.paymentDepositBankAdd")), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(DataTable, {
              columns: columnsDepositBank.value,
              data: dataRowsDepositBank.value,
              isLoaded: isDepositBankLoaded.value
            }, null, 8, ["columns", "data", "isLoaded"])
          ])
        ])
      ])
    ]),
    _createVNode(Toast, {
      show: toastConfig.value.show,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((toastConfig.value.show) = $event)),
      message: toastConfig.value.message,
      success: toastConfig.value.success
    }, null, 8, ["show", "message", "success"]),
    _createVNode(PaymentConfigAddDepositTieringDialog, {
      class: "z-10",
      show: showAddPaymentDepositTiering.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((showAddPaymentDepositTiering).value = $event)),
      form: addPaymentDepositTieringForm.value,
      "onUpdate:form": _cache[4] || (_cache[4] = ($event: any) => ((addPaymentDepositTieringForm).value = $event)),
      "deposit-bank-option": dataRowsDepositBank.value,
      "onUpdate:deposit-bank-option": _cache[5] || (_cache[5] = ($event: any) => ((dataRowsDepositBank).value = $event)),
      onSubmit: onSubmitAddPaymentDepositTiering,
      onClose: onCloseAddPaymentDepositTiering
    }, null, 8, ["show", "form", "deposit-bank-option"]),
    _createVNode(PaymentConfigEditDepositTieringDialog, {
      class: "z-10",
      show: showEditPaymentDepositTieringForm.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((showEditPaymentDepositTieringForm).value = $event)),
      form: selectedPaymentDepositTieringForm.value,
      "onUpdate:form": _cache[7] || (_cache[7] = ($event: any) => ((selectedPaymentDepositTieringForm).value = $event)),
      "deposit-bank-option": dataRowsDepositBank.value,
      "onUpdate:deposit-bank-option": _cache[8] || (_cache[8] = ($event: any) => ((dataRowsDepositBank).value = $event)),
      onSubmit: onSubmitEditPaymentDepositTiering,
      onClose: onCloseEditPaymentDepositTiering
    }, null, 8, ["show", "form", "deposit-bank-option"]),
    _createVNode(PaymentConfigAddDepositBankDialog, {
      class: "z-10",
      show: showAddPaymentDepositBank.value,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((showAddPaymentDepositBank).value = $event)),
      form: addPaymentDepositForm.value,
      "onUpdate:form": _cache[10] || (_cache[10] = ($event: any) => ((addPaymentDepositForm).value = $event)),
      "bank-provider-list": dataRowsBankProvider.value,
      "onUpdate:bank-provider-list": _cache[11] || (_cache[11] = ($event: any) => ((dataRowsBankProvider).value = $event)),
      onSubmit: onSubmitAddPaymentDepositBank,
      onClose: onCloseAddPaymentDepositBank
    }, null, 8, ["show", "form", "bank-provider-list"]),
    _createVNode(PaymentConfigEditDepositBankDialog, {
      class: "z-10",
      show: showEditPaymentDepositBank.value,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((showEditPaymentDepositBank).value = $event)),
      form: selectedEditPaymentDepositForm.value,
      "onUpdate:form": _cache[13] || (_cache[13] = ($event: any) => ((selectedEditPaymentDepositForm).value = $event)),
      "bank-provider-list": dataRowsBankProvider.value,
      "onUpdate:bank-provider-list": _cache[14] || (_cache[14] = ($event: any) => ((dataRowsBankProvider).value = $event)),
      onSubmit: onSubmitEditPaymentDepositBank,
      onClose: onCloseEditPaymentDepositBank
    }, null, 8, ["show", "form", "bank-provider-list"])
  ], 64))
}
}

})